import type { EvaluationEngine, TrainingEngine } from "@newpv/js-common"

export function isTrainingEngine(object: any): object is TrainingEngine {
  return "drawRule" in object
}

export function isEvaluationEngine(object: any): object is EvaluationEngine {
  return "getScore" in object
}
